import { z } from 'zod';

import { emailSchema, passwordSchema } from './common.js';

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1).max(128),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1).max(128),
    newPassword: passwordSchema,
  })
  .refine((value) => value.currentPassword !== value.newPassword, {
    message: 'The new password must differ from the current one.',
    path: ['newPassword'],
  });

export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

export const requestPasswordResetSchema = z.object({
  email: emailSchema,
});

export const completePasswordResetSchema = z.object({
  token: z.string().min(32).max(512),
  newPassword: passwordSchema,
});

export type CompletePasswordResetInput = z.infer<typeof completePasswordResetSchema>;

export const sessionIdSchema = z.object({
  sessionId: z.string().uuid(),
});
